import React from 'react';
import { StanButton, StanDropdown, StanInput } from '@/components';
import { useNumberFilter } from '../hooks/useNumberFilter';
import { useFloatingFilterMenu } from '../hooks/useFloatingFilterMenu';
import { BaseFilter, BaseFilterProps } from '../components/BaseFilter';
import styles from '../StanFilters.module.css';

type Props = BaseFilterProps;

/**
 * Number filter component for filtering numeric fields
 * Supports various numeric operators (equals, greater than, less than, etc.)
 */
const NumberFilter: React.FC<Props> = ({ id, label, filterItem, onApply, onClearFilter, disabled, placement }) => {
    const { menuRef, triggerProps, isOpen, handleOpenChange, closeMenu } = useFloatingFilterMenu(disabled);

    const {
        summary,
        hasSummary,
        value,
        operatorOptions,
        currentOperator,
        apply,
        clearFilters,
        // Extracted complex logic from hook
        handleInputChange,
        handleOperatorChange,
    } = useNumberFilter({
        filterItem,
        onApply,
        onClearFilter,
        disabled,
        closeMenu,
    });

    return (
        <BaseFilter
            id={id}
            label={label}
            filterItem={filterItem}
            onApply={onApply}
            onClearFilter={onClearFilter}
            disabled={disabled}
            placement={placement}
            menuRef={menuRef}
            triggerProps={triggerProps}
            summary={summary}
            hasSummary={hasSummary}
            isOpen={isOpen}
            handleOpenChange={handleOpenChange}
            clearFilters={clearFilters}
        >
            <div className={styles.formVertical}>
                <StanDropdown
                    id={`${id}-number-operator-dropdown`}
                    name='number-operator'
                    options={operatorOptions}
                    onSelect={val => handleOperatorChange(val.value)}
                    currentValue={currentOperator}
                />
                <StanInput
                    name='number-filter'
                    type='number'
                    value={value}
                    onChange={handleInputChange}
                    className={styles.fullWidth}
                    placeholder='Enter a number'
                />
                <div className='pt-2'>
                    <StanButton type='button' className={styles.applyButton} onClick={apply} name='apply-number-filter'>
                        <span>Apply</span>
                    </StanButton>
                </div>
            </div>
        </BaseFilter>
    );
};

export default NumberFilter;
